import React from 'react';

import { Modal, ModalProps } from 'react-bootstrap';

interface IProps extends ModalProps {
  children: any,
  toggleModal: any
}

const CustomModal = ({ show, children, toggleModal }: IProps) => {
    return <Modal show={show} onHide={toggleModal}>
      <Modal.Header closeButton>
          <Modal.Title>Create Customer</Modal.Title>
        </Modal.Header>
        <Modal.Body><div style={{ padding: 15 }}>{ children }</div></Modal.Body>
    </Modal>
}

export default CustomModal;